import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';

/**
 * Customizable integer Validation Pattern.
 * Allows only integers that contain a top and second level domain.
 * Can be used like this:
 *  [dsInteger]
 *  [dsInteger]="true"
 *
 *  Deactivates the integer validation:
 *  [dsInteger]="false"
 */

/**
 * Custom integer validation directive that can be used to validate any input element.
 */
@Directive({
  selector: '[dsInteger]',
  providers: [{provide: NG_VALIDATORS, useExisting: IntegerValidatorDirective, multi: true}]
})
export class IntegerValidatorDirective implements Validator {

  static inputRegex = /^-?[0-9]*$/i;
  /**
   * @param validateInteger: validation will be deactivated if this is set to false.
   */
  @Input('dsInteger') validateInteger: boolean;

  validate(control: AbstractControl): ValidationErrors {
    const isInteger = this.validateInteger === false ? true :
      IntegerValidatorDirective.inputRegex.test(String(control.value)) && '-' !== control.value;
    return !isInteger ? {dsInteger: {actual: control.value}} : null;
  }
}

